import { render, staticRenderFns } from "./class_record.vue?vue&type=template&id=7fc2ab9d&scoped=true"
import script from "./class_record.vue?vue&type=script&lang=js"
export * from "./class_record.vue?vue&type=script&lang=js"
import style0 from "./class_record.vue?vue&type=style&index=0&id=7fc2ab9d&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fc2ab9d",
  null
  
)

export default component.exports